import React, { HTMLProps, ReactNode } from "react";
import styled from "styled-components";
import { AppPropertyStatusEnum } from "../app-properties.model";

export interface IAppPropertiesStatusChipProps extends HTMLProps<HTMLDivElement> {
  type: AppPropertyStatusEnum;
  children: ReactNode;
}

const AppPropertyStatusChip = ({ type, children, ref, as, ...rest }: IAppPropertiesStatusChipProps) => {
  return (
    <StatusChipContainer type={type} {...rest}>
      {children}
    </StatusChipContainer>
  );
};

export default AppPropertyStatusChip;

export const StatusChipContainer = styled("div")<{ type: AppPropertyStatusEnum }>`
  border-radius: 10px;
  padding-left: 12px;
  padding-right: 12px;
  height: 22px;
  line-height: 21px;
  font-weight: bold;
  display: inline-block;
  font-size: 14px;
  text-align: center;
  font-family: Vodafone Rg;

  ${props => {
    let backgroundColor = "";
    let fontColor = props.theme.palette.white;
    let borderColor = "";
    switch (props.type) {
      case AppPropertyStatusEnum.LIVE:
        backgroundColor = props.theme.palette.digitalGreen;
        borderColor = props.theme.palette.digitalGreen;
        break;
      case AppPropertyStatusEnum.DISABLE:
        backgroundColor = props.theme.palette.white;
        borderColor = props.theme.palette.freshOrange;
        fontColor = props.theme.palette.freshOrange;
        break;
      case AppPropertyStatusEnum.DISABLED:
        backgroundColor = props.theme.palette.freshOrange;
        borderColor = props.theme.palette.freshOrange;
        break;
      case AppPropertyStatusEnum.ENABLE:
      case AppPropertyStatusEnum.EDIT:
        backgroundColor = props.theme.palette.white;
        fontColor = props.theme.palette.digitalGreen;
        borderColor = props.theme.palette.digitalGreen;
        break;
      case AppPropertyStatusEnum.DELETE:
        backgroundColor = props.theme.palette.vodafoneRed;
        borderColor = props.theme.palette.vodafoneRed;
        break;
    }
    return `background-color: ${backgroundColor}; color: ${fontColor}; border: 1px solid ${borderColor}`;
  }}
`;
